import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';
import moment from 'moment';

import Avatar from '@material-ui/core/Avatar';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import red from '@material-ui/core/colors/red';
import orange from '@material-ui/core/colors/orange';
import green from '@material-ui/core/colors/green';
import grey from '@material-ui/core/colors/grey';
import avatar from '@material-ui/core/colors/grey';

import * as routes from '../../../constants/routes';
import { startEditAdmin } from '../../../store/actions/admin';
import { selectInvoiceStatus } from '../../../store/selectors';

const styles = theme => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing.unit,
  },
  avatar: {
    margin: '10px',
    color: '#fff',
    backgroundColor: avatar[500],
  },
  content: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: grey[100],
    }
  },
  margin: {
    marginLeft: theme.spacing.unit*2,
    marginRight: theme.spacing.unit*2,
  },
  client: {
    width: "150px",
  },
  date: {
    width: "120px",
  },
  statusMessage: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: "center",
  },
  statusMessageSpacer: {
    marginLeft: theme.spacing.unit*2,
    marginRight: theme.spacing.unit*2,
    height: "7px",
    width: "7px",
    backgroundColor: "#bbb",
    borderRadius: "50%",
  },
  flexGrow: {
    flexGrow: 1,
  },
  divider: {
    height: '30px',
    maxWidth: '2px',
    minWidth: '2px',
    margin: '0px 0px',
    background: grey[300],
  },
  total: {
    flexBasis: '80px',
    marginLeft: theme.spacing.unit*2,
    marginRight: theme.spacing.unit*2,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  status: {
    width: "100px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
  },
});

const InvoiceCard = ({ history, classes, invoice, client, status, startEditAdmin }) => {

  const statusColor = function () {
    switch (status.warningLevel) {
      case "overdue":
        return red[500];
      case "warning":
        return orange[500];
      case "ok":
        return green[500];
      default:
        return undefined;
    }
  }();

  return(
    <Card className={classes.root}>
      <div
        className={classes.content}
        onClick={() => {
          startEditAdmin({invoice: invoice});
          history.push(routes.INVOICES);
        }}>
        <Avatar className={classNames(classes.avatar, classes.margin)}>
          I
        </Avatar>
        <div className={classNames(classes.client, classes.margin)}>
          {client &&
            <Typography noWrap variant="subheading">
              {client.fullName}
            </Typography>
          }
          <Typography variant="caption">
            {invoice.invoiceNumber !== undefined
              ? invoice.invoiceNumber.toString().padStart(6, "0")
              : ""
            }
          </Typography>
        </div>
        <div className={classes.date}>
          {invoice.invoiceDate &&
            <Typography variant="subheading">
              {moment(invoice.invoiceDate).format("MMM Do, YYYY")}
            </Typography>
          }
        </div>
        {status.message &&
          <div className={classes.statusMessage}>
            <div className={classes.statusMessageSpacer} />
            <Typography style={{ color: statusColor }}>
              {status.message}
            </Typography>
          </div>
        }
        <div className={classes.flexGrow}/>

        <div className={classes.flexGrow}/>
        <div className={classes.divider}></div>
        <Typography className={classes.total}>${invoice.grandTotal.toFixed(2)}</Typography>
      </div>
      <div className={classes.divider}></div>
      <div className={classNames(classes.status, classes.margin)}>
        <Typography
          style={{ color: statusColor }}
          variant="subheading"
        >
          {status.name}
        </Typography>
      </div>
    </Card>
  );
};

const mapStateToProps = (state, props) => {
  const { invoice } = props;
  const client = invoice.clientId === undefined
    ? undefined
    : state.clientsState.find(client => client.id === invoice.clientId);

  return ({
    client: client,
    status: selectInvoiceStatus(state, invoice),
  });
};

const mapDispatchToProps = (dispatch) => ({
  startEditAdmin: (invoice) => dispatch(startEditAdmin(invoice))
});

export default compose(
  withStyles(styles),
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
)(InvoiceCard);



// WEBPACK FOOTER //
// ./src/components/admin/Invoices/InvoiceCard.jsx